import { ContainerComment, Subtitle } from '../DetailsRoomsBathrooms/styles';
import { useSelector } from 'react-redux';
import OneDimensionTable from '../OneDimensionTable/OneDimensionTable';
import { handleGenerateComent } from './utils';

const DetailElevatorTypology = () => {
  const stateCards = useSelector((state: any) => state.cardsStore.stateCards);
  const filteredData = stateCards?.filter(
    (item: { id: number }) => item?.id === 10
  );

  // Validar que filteredData tenga al menos un elemento
  if (!filteredData || filteredData.length === 0 || !filteredData[0]?.data) {
    return <div>No hay datos disponibles para la tipología de ascensores</div>;
  }

  const cardData = filteredData[0].data;

  return (
    <>
      <ContainerComment>
        <div className="title">Comentario: </div>
        <div className="subtitle">
          {handleGenerateComent(
            cardData.approval_result,
            cardData.nid,
            cardData.elevator,
            cardData.median_zone,
            cardData.dataTable
          )}
        </div>
      </ContainerComment>
      <Subtitle>Cantidad de ascensores</Subtitle>
      <OneDimensionTable
        data={cardData.dataTable}
        pivot="total_count"
        countPivot="num_elevators"
        totalRows={1}
        pivotValue={cardData.elevator}
      />
      <Subtitle>Porcentaje de ascensores</Subtitle>
      <OneDimensionTable
        data={cardData.dataTable}
        pivot="total_percentage"
        countPivot="num_elevators"
        totalRows={1}
        pivotValue={cardData.elevator}
      />
    </>
  );
};

export default DetailElevatorTypology;
